import { List, Show, Edit, FilterButton, useNotify, Create, required, Toolbar, SaveButton } from 'react-admin'
import { useWatch } from "react-hook-form";
import { Datagrid, ReferenceField, FormDataConsumer, DateField, DateInput, TextField, AutocompleteInput, NumberField, NumberInput, ReferenceInput, SelectField, SelectInput, PasswordInput, BooleanField, EmailField, BooleanInput, SimpleShowLayout, TopToolbar, ListButton, ShowButton, SimpleForm, TextInput} from 'react-admin';


export const MarketplaceItemRecordRepresentation = (record) => {
    let s = `${record.productName}:`;
    if (record.name) {
        s += ` ${record.name}`
    }
    s += ` [${record.description}]`
    return s;
}

const marketplaceItemFilters = [
    // <TextInput label="Email" source="email" defaultValue="" alwaysOn/>,
    // <SelectInput label="Subject" source="subject" defaultValue="" alwaysOn choices={licenseTypes}/>,
];

export const MarketplaceItemList = () => (
    <List filters={marketplaceItemFilters}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="sku"/>
            <TextField source="productId" label="Paddle ProductID"/>
            <TextField source="collectionSlug" label="Collection Slug"/>
            {/* <TextField source="priceId"/> */}
            {/* <TextField source="salePriceId"/> */}
            <BooleanField source="salePriceActive"/>
            <BooleanField source="published"/>
            <BooleanField source="archived"/>
        </Datagrid>
    </List>
);

export const MarketplaceItemShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
        <TextField source="id"/>
        <TextField source="name"/>
        <TextField source="sku"/>
        <TextField source="productId" label="Paddle ProductID"/>
        <TextField source="collectionSlug" label="Collection Slug"/>
        <ReferenceField source="priceId" reference="prices" label="MSRP Price" />
        <ReferenceField source="salePriceId" reference="prices" label="Sale Price" />
        <BooleanField source="salePriceActive"/>
        <BooleanField source="published"/>
        <BooleanField source="archived"/>
        </SimpleShowLayout>
    </Show>
);

export const MarketplaceItemCreate = (props) => {
    return (
        <Create {...props} redirect="show">
            <SimpleForm>
                <ReferenceInput label="ProductSku" source="productSkuId" reference="product-skus">
                    <SelectInput validate={required()} fullWidth/>
                </ReferenceInput>
                 <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.productSkuId && (<>
                            <ReferenceInput source="priceId" reference="prices" filter={{ productSkuId: formData.productSkuId }}>
                                <SelectInput validate={required()} fullWidth/>
                            </ReferenceInput>
                            <ReferenceInput source="salePriceId" reference="prices" filter={{ productSkuId: formData.productSkuId }}>
                                <SelectInput fullWidth/>
                            </ReferenceInput>
                        </>)
                    }
                </FormDataConsumer>
                
                <BooleanInput source="salePriceActive"/>
                <BooleanInput source="published"/>
            </SimpleForm>
        </Create>
    );
}

const MarketplaceItemEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const MarketplaceItemEdit = (props) => {
    const transform = data => ({
        published: data.published,
        archived: data.archived,
        salePriceId: data.salePriceId,
        salePriceActive: data.salePriceActive
    });

    return (
        <Edit transform={transform} {...props}>
            <SimpleForm toolbar={<MarketplaceItemEditToolbar />}>
                <ReferenceField source="priceId" reference="prices" label="MSRP Price" />
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.productSkuId && (<>
                            <ReferenceInput source="salePriceId" reference="prices" filter={{ productSkuId: formData.productSkuId }}>
                                <SelectInput fullWidth/>
                            </ReferenceInput>
                        </>)
                    }
                </FormDataConsumer>
                <BooleanInput source="published"/>
                <BooleanInput source="archived"/>
                <BooleanInput source="salePriceActive"/>
            </SimpleForm>
        </Edit>
    );
}
